import Popup from 'components/ui/popup'
import { WhiteListItem as WhiteListItemType } from 'store/reducers/settings'
import { Dispatch, SetStateAction, useMemo, useState } from 'react'
import ButtonBlue from 'components/ui/button/_color/_blue'
import ButtonWhite from 'components/ui/button/_color/_white'

import { _deleteWhitelistWallets } from 'store/fetchers/wallets'

import styles from './styles.module.scss'
import { useTranslation } from 'utils/use-translation'
import ConfirmData from '../add-address-popup/components/confirm-data'

export const DeleteAddressPopup = ({
  refetch,
  setPopupIsVisible,
  item,
}: {
  refetch: () => void
  setPopupIsVisible: Dispatch<SetStateAction<WhiteListItemType>>
  item: WhiteListItemType
}) => {
  const { t } = useTranslation()
  const [step, setStep] = useState<1 | 2>(1)
  const [isLoading, setIsLoading] = useState(false)
  const [currentItem, _] = useState(item)

  const onClose = () => {
    setPopupIsVisible(null)
  }

  const handleDelete = async () => {
    setIsLoading(true)

    const res = await _deleteWhitelistWallets({
      code: item.currency.code,
      address_name: item.address_name,
      network: item.currency.network,
      address: item.address,
      tag: item.extraId,
    })

    if (res) {
      refetch()
      setStep(2)
    }    

    setIsLoading(false)
  }

  const title = useMemo(() => {
    switch (step) {
      case 2: return t('address_deleted')
      default: return t('delete_address')
    }
  }, [step])

  const subtitle = useMemo(() => {
    switch (step) {
      case 2: return t('address_deleted_from_whitelist')
      default: return t('check_address')
    }
  }, [step])

  return (
    <Popup
      onClose={onClose}
      heading={title}
      subtitle={subtitle}
      className={styles.popup}
      crossIconBtnStyle={styles['icon__cross']}
      titleClassName={styles.title}
      subtitleClassName={styles.subtitle}
      mainClassName={styles.main}
    >
      <ConfirmData
        currencyInfo={currentItem?.currency}
        address={currentItem?.address}
        hasTag={Boolean(currentItem?.extraId)}
        tag={currentItem?.extraId}
        className={styles['confirm-data']}
      />

      {step === 1 && (
        <div className={styles.footer}>
          <ButtonWhite onClick={onClose} className={styles['button__white']}>
            {t('cancel')}
          </ButtonWhite>
          <ButtonBlue
            isLoading={isLoading}
            disabled={isLoading}
            onClick={handleDelete}>
              {t('confirm')}
          </ButtonBlue>
        </div>
      )}

      {step === 2 && (
        <div className={styles.footer}>
          <ButtonBlue onClick={onClose}>{t('close')}</ButtonBlue>
        </div>
      )}
    </Popup>
  )
}
